import { useNode } from "@craftjs/core";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Switch } from "@/components/shared/switch";

import type { VideoGridProps } from "../video-grid";

export const AdvancedSettings = () => {
  const { t } = useTranslation();
  const {
    props,
    actions: { setProp },
  } = useNode((query) => ({
    props: query.props as VideoGridProps,
  }));

  const handleVideoTitleToggle = useCallback(() => {
    setProp((props) => {
      props["videoTitleEnabled"] =
        props["videoTitleEnabled"] === undefined
          ? true
          : !props["videoTitleEnabled"];
    });
  }, [setProp]);

  return (
    <div className="mt-2 flex flex-col items-start justify-between">
      <h2 className="mb-2 text-sm font-medium">
        {t("preference-panel.advanced-settings")}
      </h2>
      <div className="flex flex-row items-center gap-2">
        <Switch
          label={t("preference-panel.video-grid-enable-video-title")}
          defaultChecked={Boolean(props.videoTitleEnabled)}
          onChange={handleVideoTitleToggle}
        />
        <p className="text-sm">
          {t("preference-panel.video-grid-enable-video-title")}
        </p>
      </div>
    </div>
  );
};
